import PerfectScrollbar from 'perfect-scrollbar'

class SideNav {
  static async init () {
    if ($('body').hasClass('side-navigation')) {
      const ps = new PerfectScrollbar('#site-header', {})
      ps.update()
    }
  }
}

$(function () {
  SideNav.init()
})
